import apiUrl from '../../../constants'
import CryptoJS from 'crypto-js';
import axios from 'axios'
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'

export default {
  name: 'AutoHandover-Batch-Details',
  components: { 
    BasicSelect,
    VueElementLoading
  },
  data: function() {
    return {
      isLoadingPrint:false,
      BatchDetailsData:[],
      PrintDate:'',
      PrintBy:'',
      batchdatafound :false,
      isEcomFlag :false,
      category:"",
      autoHandoverBatchData : [],
      BatchDetails :{},
      inscanFlag :false,
      // HUB-8058: cache of {code,label} pairs from getComboHubShortageReasonMaster
      // used to render human-friendly reason text in the Reason column
      // instead of raw enum codes ("damaged", "not_received", ...).
      shortageReasons: [],
      // HUB-8058: derived from the per-row status list. Rows count as shortage
      // when status matches 'BagShortage' (Ecom) or 'Shortage' (Cargo) - see
      // huboperation-apis Constants.js BagShortageStatus / ShipmentShortageStatus.
      shortageCount: 0

    }
  },
  created: function() {},
  model: {},
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
   
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.printDate = moment().format('DD-MM-YYYY');
    this.printBy = userdetail[0].email;
    // HUB-8058: fetch reason master in parallel with the batch load. Independent
    // of getBatchDataForViewDownload - the row-mapping loop tolerates an empty
    // reasons cache (labels fall back to the raw code) so a slow master fetch
    // does not delay the batch render.
    this.fetchShortageReasons();
    this.getBatchDataForViewDownload();
    
  },
  methods: {

    getBatchDataForViewDownload() {
      const batchid = this.$route.params.batchid ;
      const currenthubid  = this.$route.params.currenthubid ;
      const isEcom = this.$route.params.isEcom;
      this.autoHandoverBatchData = [];
      this.BatchDetails = {};
      this.PrintBy = this.createdBy
      this.PrintDate = new Date();
      this.input = ({});
      this.isLoadingPrint = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getComboHubBatchListDetailsForViewDownloads?batchId=' + batchid + '&currentHubID=' + currenthubid + '&isEcom=' + isEcom,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingPrint = false;
          if (result.data.ResultCode == 100) {
             this.BatchDetails = result.data.ResponseData;
             if(this.BatchDetails.status== 'InScan'){
              this.inscanFlag = true;
             }
            // HUB-8058: reset the derived shortage count on each reload so
            // navigating between print pages does not accumulate a stale value.
            this.shortageCount = 0;
            if(this.BatchDetails.Bagcount && this.BatchDetails.Bagcount!= 0){
              let Bags = this.BatchDetails.bagData;
              for(let i= 0 ; i < Bags.length; i++){
                // HUB-8058: server already returns ahbd.status + ahbd.comment
                // (per getComboHubBatchListDetailsForViewDownloads). Passing
                // them through unlocks the Status / Reason columns without any
                // server change. Legacy pre-HUB-8058 rows carry status
                // 'OutScan' / 'InScan' and null comment - handled cleanly.
                const isShortage = Bags[i].status === 'BagShortage';
                if(isShortage) this.shortageCount++;
                this.autoHandoverBatchData.push({
                  bagno: Bags[i].bagno,
                  destination:Bags[i].finaldestinationhubname,
                  groupno:Bags[i].groupno,
                  groupname:Bags[i].groupname,
                  status: Bags[i].status,
                  isShortage: isShortage,
                  reason: isShortage ? Bags[i].comment : null
                })
            }
          }else if(this.BatchDetails.AWBcount && this.BatchDetails.AWBcount!=0){
            const  mpsData = this.BatchDetails.mpsData;
            for(let i= 0 ; i < mpsData.length; i++){
              // HUB-8058: mirror of the Ecom mapping above. Cargo shortage rows
              // land in autohandoverbatchdetails with status='Shortage' (see
              // Constants.js ShipmentShortageStatus / AutohandoverShortage.js
              // markShipmentShortageForBatch UPDATE). comment holds the raw
              // reasonCode enum value.
              const isShortage = mpsData[i].status === 'Shortage';
              if(isShortage) this.shortageCount++;
              this.autoHandoverBatchData.push({
                parentawb: mpsData[i].parentawb,
                mpsid:mpsData[i].mpsid,
                destination:mpsData[i].finaldestinationhubname,
                status: mpsData[i].status,
                isShortage: isShortage,
                reason: isShortage ? mpsData[i].comment : null
              })
          }
        }
        this.batchdatafound = true;
        this.isEcomFlag = this.$route.params.isEcom == "true"?true:false;
        this.category = isEcom== "true" ? "B2C" : "B2B";
            
          } else {
  
            this.autoHandoverBatchData = [];
            this.$alertify.error("No record found")
          }
        }, error => {
          this.isLoadingPrint = false;
          console.error(error)
        })
      } 
    ,
    

    // HUB-8058: pull the reason-code master (cached server-side in Redis for
    // 7 days per PR-1) so the Reason column can render human labels
    // ("Damaged", "Not received", ...) instead of the raw enum ("damaged",
    // "not_received"). Silent failure is acceptable - shortageReasonLabel
    // falls back to the raw code if the master never loaded.
    fetchShortageReasons() {
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'getComboHubShortageReasonMaster',
        headers: { 'authorization': 'authkey xB84JJ89Hd25' }
      }).then(result => {
        const response = result.data;
        if(response && response.ResultCode == 100 && Array.isArray(response.ResponseData)){
          this.shortageReasons = response.ResponseData;
        }
      }, error => {
        // eslint-disable-next-line no-console
        console.error('fetchShortageReasons failed on print view', error);
      });
    },

    // HUB-8058: safe accessor - returns '' for null / missing codes, the
    // matched label if the master loaded, or the raw code as a last resort.
    // Called inline from the Reason column template.
    shortageReasonLabel(code) {
      if(!code) return '';
      const match = this.shortageReasons.find(r => r.code === code);
      return match ? match.label : code;
    },

    printBatch() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:2px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .td-width{
             width:10px!important;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           /*
            * HUB-8058: mirror of the scoped .row-shortage rule in the SCSS.
            * Printd renders inside a detached iframe that does NOT pull the
            * component's scoped styles, so the highlight has to be redeclared
            * here. -webkit-print-color-adjust:exact forces Chrome / Edge to
            * keep the background colour in the printed PDF.
            */
           tr.row-shortage td{
             background-color:#fdecea !important;
             -webkit-print-color-adjust:exact;
             print-color-adjust:exact;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
           tr.row-shortage td{
             background-color:#fdecea !important;
           }
          }
          `
      d.print(document.getElementById('batchsheetContent'), cssText);
    },


    
    

  }
}




// WEBPACK FOOTER //
// ./src/views/components/AutoHandoverBatchDetailsPrint/AutoHandoverBatchDetailsPrint.js